import React, { useEffect, useState } from "react";
import "../../../css/pc/versionBadge.css";

// Displays a vertical label on the right side: "ESSP vX.Y" where X.Y is from package.json
// Version is exposed by Vite define as __APP_VERSION__ in vite.config.js
export const VersionBadge = () => {
  // Fallback if define is missing
  const raw =
    typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";

  // Extract major.minor from version string
  const match = String(raw).match(/^(\d+)\.(\d+)/);
  const majorMinor = match ? `${match[1]}.${match[2]}` : raw;
  const text = `ESSP v${majorMinor}`;

  // State for dynamic positioning when Jira Issue Collector is present
  const [style, setStyle] = useState({
    top: "50%",
    transform: "translateY(-50%)",
  });

  useEffect(() => {
    const margin = 20; // gap between feedback tab and version badge

    const findTrigger = () => {
      // Common selectors for Atlassian Issue Collector trigger
      return (
        document.querySelector(".atlwdg-trigger") ||
        document.querySelector("a[id*='atlwdg'][class*='trigger']") ||
        document.querySelector("a[title*='feedback' i]") ||
        document.querySelector("a[aria-label*='feedback' i]")
      );
    };

    const positionBadge = () => {
      const trigger = findTrigger();
      if (trigger) {
        const rect = trigger.getBoundingClientRect();
        // Place our badge just below the feedback tab, flush to right edge
        setStyle({ top: `${rect.bottom + margin}px`, transform: "none" });
      } else {
        // Default: center right
        setStyle({ top: "50%", transform: "translateY(-50%)" });
      }
    };

    // Initial position
    positionBadge();

    // Reposition on resize (in case feedback tab moves)
    const onResize = () => positionBadge();
    window.addEventListener("resize", onResize);

    // Observe DOM for when the feedback tab is injected dynamically
    const observer = new MutationObserver(() => positionBadge());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("resize", onResize);
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className="version-badge"
      style={style}
      aria-label={`Application version ${text}`}
    >
      <span>{text}</span>
    </div>
  );
};

export default VersionBadge;
